var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParagraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8L1 12L5 16",
    stroke: "#0973F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8L23 12L19 16",
    stroke: "#0973F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M10.5818 9.364C10.8338 9.00933 11.1791 8.71533 11.6178 8.482C12.0658 8.23933 12.5744 8.118 13.1438 8.118C13.8064 8.118 14.4038 8.28133 14.9358 8.608C15.4771 8.93467 15.9018 9.40133 16.2098 10.008C16.5271 10.6053 16.6858 11.3007 16.6858 12.094C16.6858 12.8873 16.5271 13.592 16.2098 14.208C15.9018 14.8147 15.4771 15.286 14.9358 15.622C14.4038 15.958 13.8064 16.126 13.1438 16.126C12.5744 16.126 12.0704 16.0093 11.6318 15.776C11.2024 15.5427 10.8524 15.2487 10.5818 14.894V19.696H8.62176V8.244H10.5818V9.364ZM14.6838 12.094C14.6838 11.6273 14.5858 11.226 14.3898 10.89C14.2031 10.5447 13.9511 10.2833 13.6338 10.106C13.3258 9.92867 12.9898 9.84 12.6258 9.84C12.2711 9.84 11.9351 9.93333 11.6178 10.12C11.3098 10.2973 11.0578 10.5587 10.8618 10.904C10.6751 11.2493 10.5818 11.6553 10.5818 12.122C10.5818 12.5887 10.6751 12.9947 10.8618 13.34C11.0578 13.6853 11.3098 13.9513 11.6178 14.138C11.9351 14.3153 12.2711 14.404 12.6258 14.404C12.9898 14.404 13.3258 14.3107 13.6338 14.124C13.9511 13.9373 14.2031 13.6713 14.3898 13.326C14.5858 12.9807 14.6838 12.57 14.6838 12.094Z",
    fill: "#00AEEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraph);
export default __webpack_public_path__ + "static/media/paragraph.180b1bff.svg";
export { ForwardRef as ReactComponent };